import type { MouseEvent, ReactElement } from 'react'
import type { IconNamesType } from '../../generated/enums/icon-enum'
import type { HTMLImgProps } from '../../types'
import type NamedIconHoC from './NamedIconHoC'

export enum IconSize {
  small = 's',
  medium = 'm',
  large = 'l',
  xlarge = 'xl',
}

export type IconSizeType = `${IconSize}`

export interface IconBaseProps {
  className?: string
  onClick?: (e: MouseEvent) => void
  size?: IconSizeType
}

export type IconProps =
  | (IconBaseProps & HTMLImgProps & { name?: undefined })
  | (IconBaseProps &
      NamedIconPropsType & {
        name: IconNamesType
        alt: string
      })

export type NamedIconPropsType = IconBaseProps & {
  outline?: boolean
  rtl?: boolean
  children?: React.ReactNode
}

export type NamedIconComponentType = React.ComponentType<React.ComponentProps<typeof NamedIconHoC>>
export type IconComponentType = ReactElement<IconProps>
